module.exports = __webpack_public_path__ + "img/EAQ08_L.0574bfe6.png";